// extracted by mini-css-extract-plugin
module.exports = {"nav":"Layout_nav__3Ss6G","footer":"Layout_footer__3EtpL"};